import { render, staticRenderFns } from "./ItemPacksNew.vue?vue&type=template&id=5cbe3a34"
import script from "./ItemPacksNew.vue?vue&type=script&lang=js"
export * from "./ItemPacksNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports